import {BitrixVue} from 'ui.vue3'
import {createStore} from "ui.vue3.vuex"
import {Widget} from "./components/widget"

export class Authwidget
{
	constructor(rootNode, data)
	{
		this.rootNode = document.querySelector(rootNode)
		this.data = data
	}

	start() {
		const context = this

		const store = createStore({
			state() {
				return context.data
			},
			actions: {},
			mutations: {}
		})

		let application = BitrixVue.createApp({
			name: 'Authwidget',
			components: {Widget},
			beforeCreate() {
				this.$bitrix.Application.set(context);
			},
			template: '<Widget />'
		})

		application.use(store)
		application.mount(this.rootNode)
	}
}
